/* eslint-disable no-nested-ternary */
import { useState } from 'react';
import OrdersTableSkeleton from './OrdersTableSkeleton';
import { useGetAllCouponsQuery } from '../store';
import CustomModal from './atoms/CustomModal';
import CouponsTable from './CouponsTable';
import CreateEditCoupon from './CreateEditCoupon';
import useGetParams from '../hooks/useGetParams';
import AdminSectionTitle from './AdminSectionTitle';
import useGetSelectedEvent from '../hooks/useGetSelectedEvent';
import Sale01 from './icons/Sale01';

const CRUDCoupon: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const { event } = useGetSelectedEvent();
  const { eventId, businessId } = useGetParams();

  const { data: coupons, isFetching } = useGetAllCouponsQuery({
    businessId,
    eventId,
  });

  const handleSucessAddCoupon = () => {
    setShowModal(false);
  };

  const handleAddCoupon = () => {
    setShowModal(true);
  };

  return (
    <div className="flex flex-col gap-8 my-6">
      <AdminSectionTitle title="Eventos" subtitle={`${event?.name} - Cupones`} />
      <div className="glass-surface">
        <h1 className="text-2xl font-medium mb-2">Cupones</h1>
        {isFetching && <OrdersTableSkeleton />}{' '}
        {coupons && (
          <CouponsTable coupons={coupons} eventId={eventId} businessId={businessId} button={{
            label: 'Crear nuevo cupón',
            onClick: handleAddCoupon,
            variant: 'secondary',
            reactIcon: <Sale01 className='text-xl'/>,
          }} />
        )}
      </div>
      <CustomModal
        onRequestClose={() => setShowModal(false)}
        isOpen={showModal}
        hideCancelButton={true}
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <h1 className="text-xl font-medium">Crear cupón</h1>
            <p className="text-text-tertiary text-sm">

              Podrás realizar las ediciones que necesites en este cupón
            </p>
          </div>
          <CreateEditCoupon onSuccess={handleSucessAddCoupon} onCancel={() => setShowModal(false)} />
        </div>
      </CustomModal>
    </div>

  );
};

export default CRUDCoupon;
